<template>
    <v-dialog
        v-model="dialog"
        width="1200px"
    >
        <template v-slot:activator="{ on, attrs }">
            <v-btn
                color="primary"
                text
                small
                v-bind="attrs"
                v-on="on"
            >
                <v-icon left color="blue-grey">mdi-link-box</v-icon>
                <span class="blue-grey--text">Contextual Realation</span>
            </v-btn>
        </template>
        <v-card>
            <v-card-title>
                Contextual Realation
                <v-spacer></v-spacer>
                <v-text-field
                    v-model="search"
                    append-icon="mdi-magnify"
                    label="Search"
                    single-line
                    hide-details
                ></v-text-field>
            </v-card-title>
            <v-card-text>
                <v-data-table
                :items-per-page="200"
                hide-default-footer
                fixed-header
                height="600"
                :headers="headers"
                :items="contextualRelation"
                :search="search"
                ></v-data-table>
            </v-card-text>
        </v-card>
    </v-dialog>
</template>

<script>
export default {
    props: [ 'items' ],
    data() {
        return {
            dialog: false,
            search: '',
            headers: [
                {
                    text: 'ID',
                    align: 'start',
                    sortable: false,
                    value: 'slug',
                },
                { text: 'Source', value: 'source' },                
                { text: 'Relation', value: 'relation' },
                { text: 'Target', value: 'target' },
                { text: 'Note', value: 'note' },
                { text: 'Attribute', value: 'attribute' },
            ],
        }
    },
    computed: {
        contextualRelation() {
            let newItems = []
            this.items.forEach(item => {
                item.contextualRelation.forEach(relation => {
                    newItems.push({...relation, slug: item.nodeDescription.id, id: Math.random()})
                })
            })
            return newItems            
        }
    }
}
</script>

<style>

</style>